export type InvitationContactType = 'whatsapp' | 'email';

export const MAX_INVITATION_REMINDERS = 3;
